import template from './adminPermissions.html';
import controller from './adminPermissions.controller';

let adminPermissionsComponent = {
  restrict: 'E',
  bindings: {
    customer: '=',
    admin: '='

  },
  template,
  controller,
  controllerAs: 'vm'
};

export default adminPermissionsComponent;



// WEBPACK FOOTER //
// ./app/components/adminPermissions/adminPermissions.component.js